export default { 
  firebase:{
    apiKey: "AIzaSyDhr7e9SgJuRN8v5OGq8EUWrGQS3nd9W4Y",
    authDomain: "the-unit-planner.firebaseapp.com",
    databaseURL: "https://the-unit-planner.firebaseio.com",
    projectId: "the-unit-planner",
    storageBucket: "the-unit-planner.appspot.com",
    messagingSenderId: "445466966323"
  },
  google: {
		client_id: '****.apps.googleusercontent.com',	
		api_key: '****',
		hosted_domain: '****.com',
		scope: 'profile email https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/plus.login',
		discovery_docs: [	      
			'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest', 
			'https://people.googleapis.com/$discovery/rest?version=v1'
		],
	},
  };


// WEBPACK FOOTER //
// ./src/config.js